<template xmlns="http://www.w3.org/1999/html">

  <div style="width: 100%;
    position:fixed;
    background: url(/static/images//huaku/fullbg.png) no-repeat center center;
    background-size: cover;
    background-position: top;
    height: 100%;
    overflow: hidden;top: 0; left: 0; right: 0; bottom: 0;z-index: 0;">
    <img src="/static/images/huaku/logo.png" style="width: 78%;position: absolute;left: 11%;top:10%"/>
    <img src="/static/images/huaku/pingzi.png" style="width: 15%;position: absolute;right: 13%;bottom:2%"/>

    <!-- 扫码页面开始 -->
    <div v-if="showScanPage"
      style="position: absolute;top:32%;display: flex;flex-direction: column;justify-content:center;align-items: center;">
      <img src="/static/images/huaku/fangwei.png" style="width: 75%;" />
      <div
        style="width: 75%;background-color: white;margin-top:10px;padding-top:8px;padding-bottom: 8px;border: 0px;text-align: center;border-radius: 7px;font-size: 14px;">
        瓶身刮开涂层，扫一扫或输入防伪码
      </div>
      <div style="width: 75%;background-color: white;margin-top:10px;padding-top:3px;padding-bottom: 3px;
        border: 0px;text-align: left;border-radius: 7px;font-size: 14px;padding-top:10px;padding-bottom: 10px;padding-left:5%;padding-right: 5%;
        display: flex;flex-direction: column;">
        <span style="color:rgb(141,141,141);">扫一扫查防伪</span>
        <div @click="scanCode"
          style="width: 100%;background-color: rgb(46, 96, 63);margin-top: 10px;color: white;display: flex;align-items: center;justify-content: center;height: 32px;border: 0px;text-align: center;border-radius: 7px;font-size: 14px;">
          <img src="/static/images/huaku/scan.png" style="width: 14px;" />
          &nbsp;&nbsp;点击扫码
        </div>
        <span style="color:rgb(141,141,141);margin-top: 10px;">输入查防伪</span>
        <div class="input-container">
          <input type="text" v-model="antiCode" placeholder="请输入16位防伪码" class="anti-code-input" @input="handleInput" />
          <button class="confirm-button" @click="getAntiInput">确定</button>
        </div>
      </div>
    </div>
    <!-- 扫码页面结束 -->


    <!--查询结果成功页面开始 -->
    <div v-if="showSuccessPage"
      style="position: absolute;top:32%;width: 100%;display: flex;justify-content:center;align-items: center;">
      <div style="width: 85%;background-color: white;margin-top:10px;padding-top:3px;padding-bottom: 3px;
        border: 0px;text-align: left;border-radius: 7px;font-size: 13px;padding-top:10px;padding-bottom: 10px;padding-left:5%;padding-right: 5%;
        display: flex;flex-direction: column;">
        <div
          style="width: 100%;margin-top: 18px;display: flex;justify-content:center;align-items: center;text-align: center;font-size: 18px;">
          防伪码：{{ this.antiCodeShow }}
        </div>
        <div
          style="width: 100%;margin-top: 3px;display: flex;justify-content:center;align-items: center;text-align: center;font-size: 15px;">
          当前查询数码
        </div>
        <div
          style="width: 100%;margin-top: 12px;padding:0% 5% 0% 5%;display: flex;justify-content:left;align-items: center;text-align: left  ;font-size: 15px;">
          您好! 您所查询的是: 健养堂的产品为品牌正品。同时认准品牌官方公众号“健养堂健康指南”，双重认证请放心使用。感谢您对健养堂品牌的信任与支持!
        </div>
        <div
          style="width: 100%;margin-top: 12px;padding:0% 5% 0% 5%;display: flex;justify-content:left;align-items: center;text-align: left;font-size: 15px;">
          查询记录：
        </div>
        <div
          style="width: 100%;margin-top: 5px;margin-bottom: 15px;padding:0% 5% 0% 5%;display: flex;justify-content:left;align-items: center;text-align: left;font-size: 15px;">
          首次查询：{{ this.firstQueryTime }}
        </div>
      </div>
    </div>
    <!-- 查询结成功页面结束 -->

    <!--查询结果失败页面开始 -->
    <div v-if="showErrorPage"
      style="position: absolute;top:32%;width: 100%;display: flex;justify-content:center;align-items: center;">
      <div style="width: 85%;background-color: white;margin-top:10px;padding-top:3px;padding-bottom: 3px;
        border: 0px;text-align: left;border-radius: 7px;font-size: 13px;padding-top:10px;padding-bottom: 10px;padding-left:5%;padding-right: 5%;
        display: flex;flex-direction: column;">
        <div
          style="width: 100%;margin-top: 18px;display: flex;justify-content:center;align-items: center;text-align: center;font-size: 18px;">
          防伪码：{{ this.antiCodeShow }}
        </div>
        <div
          style="width: 100%;margin-top: 3px;display: flex;justify-content:center;align-items: center;text-align: center;font-size: 15px;">
          当前查询数码
        </div>
        <div
          style="width: 100%;margin-top: 12px;padding:0% 5% 0% 5%;display: flex;justify-content:left;align-items: center;text-align: left  ;font-size: 15px;">
          您好！该防伪码已被查询过，该防伪码已失效，警防假冒!
        </div>
        <div
          style="width: 100%;margin-top: 12px;padding:0% 5% 0% 5%;display: flex;justify-content:left;align-items: center;text-align: left;font-size: 15px;">
          查询记录：
        </div>
        <div
          style="width: 100%;margin-top: 5px;margin-bottom: 15px;padding:0% 5% 0% 5%;display: flex;justify-content:left;align-items: center;text-align: left;font-size: 15px;">
          首次查询：{{ this.firstQueryTime }}
        </div>
      </div>

      <div v-show="isShow">
        <div id="fixedBg"></div>
        <p class="loading_p" id="loadP">
          <img src="/static/images/loadding.gif" />
        </p>
      </div>
    </div>
    <!-- 查询结失败页面结束 -->


  </div>
</template>
<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>

<style scoped>
.input-container {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 25px;
  overflow: hidden;
  width: 100%;
  /* Adjust width as needed */
  margin-top: 10px;
}

.anti-code-input {
  border: none;
  padding: 0px 0px 0px 10px;
  flex: 1;
  font-size: 14px;
}

.confirm-button {
  background-color: #2E603E;
  /* 深绿色背景 */
  color: white;
  border: none;
  padding: 5px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 0 10px 10px 0;
  outline: none;
}

.confirm-button:hover {
  background-color: #24503A;
  /* Slightly darker green on hover */
}
</style>

<script>
import { getAntiData, getJSSDK, getAntiResult } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      isShow: false,
      antiCode: "",
      firstQueryTime: "",
      showScanPage: true,
      showSuccessPage:false,
      showErrorPage: false,
      antiCodeShow: "",
      eno: ""
    }
  },
  methods: {
    handleInput() {
      this.antiCode = this.antiCode.replace(/(\w{4})(?=\w)/g, '$1 ');
    },
    getResult(scanQRCode) {
      this.isShow = true
      getAntiResult(scanQRCode).then(res => {
        const data = res.data;
        if (data == null || data.code == "500") {
          this.isShow = false
          this.showScanPage = true
          this.showSuccessPage = false
          this.showErrorPage = false
          alert("防伪查询失败,请联系管理员");
        } else if (data.code == "300106") {
          this.showScanPage = true
          this.showSuccessPage = false
          this.showErrorPage = false
          alert(data.message);
        } else {
          this.antiCodeShow = this.insertSpace(data.data.code)
          this.firstQueryTime = data.data.firstQueryTime
          if (data.code === "300102") {
            this.showScanPage = false
            this.showSuccessPage = false
            this.showErrorPage = true
          } else if (data.code == "300101") {
            this.showScanPage = false
            this.showSuccessPage = true
            this.showErrorPage = false
          }
        }
        this.isShow = false
      }).catch(err => {
        this.isShow = false
        console.log(err)
        alert("查询异常，请联系管理员")
      })

    },
    getAntiInput() {
      const code = this.antiCode.replace(/ /g, '');
      if (code.length != 16) {
        alert("请输入正确的16位防伪码");
        return;
      }
      this.isShow = true
      getAntiData(code, this.eno).then(res => {
        const data = res.data;
        if (data == null || data.code == "500") {
          this.isShow = false
          this.showScanPage = true
          this.showSuccessPage = false
          this.showErrorPage = false
          alert("防伪查询失败,请联系管理员");
        } else if (data.code == "300106") {
          this.showScanPage = true
          this.showSuccessPage = false
          this.showErrorPage = false
          alert(data.message);
        } else {
          this.antiCodeShow = this.insertSpace(data.data.code)
          this.firstQueryTime = data.data.firstQueryTime
          if (data.code === "300102") {
            this.showScanPage = false
            this.showSuccessPage = false
            this.showErrorPage = true
          } else if (data.code == "300101") {
            this.showScanPage = false
            this.showSuccessPage = true
            this.showErrorPage = false
          }
        }
        this.isShow = false
      }).catch(err => {
        this.isShow = false
        console.log(err)
        alert("查询异常，请联系管理员")
      })

    },
    insertSpace(code) {
      return code.replace(/\d{4}/g, function (match) {
        return match + ' ';
      });
    },
    scanCode() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          var scanResult= res.resultStr
          var scanQRCode=scanResult
          if(scanResult.startsWith('http')){
            let parts = scanResult.split('/');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : '';
          }
          this.getResult(scanQRCode)
        }
      });
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wxbc22565b3e7a59fd").then(res => {
        console.log(res)
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  created: function () {
    this.getWxJs()
    const params = this.$route.query;
    this.eno = params.eno;
    if (this.eno == "" || this.eno == undefined) {
      alert("请使用正确入口地址进行查询")
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HuaKu/Scan.vue